export default __webpack_public_path__ + "static/media/microsoft.e26eb792.svg";